export function currentDateTime() {
	var options = {
		hourCycle: 'h11',
		weekday: 'long',
		year: 'numeric',
		month: 'long',
		day: '2-digit',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric'
	};

	return new Date().toLocaleDateString('en-US', options);
}